// removed by extract-text-webpack-plugin
module.exports = {"GridPack":"_1yf0tM8Bdgd8e8yuuPKZGr","GridPack__wrap":"_35ZQmyT2eDU5I-uNP44AXR","GridPack__guts":"nEmFNvBgQPtVXymzbdx5I","GridPack__comingSoon":"BGPo2uT5LqTpDRVlpc2FR","GridPack__title":"_2vWUfp-Up4sIP8MBNI1369","GridPack__description":"_1njCgJewW2hi8QvPFxg659","GridPack__actions":"_1EW-A1cEhrVzxHFBSnQnbU","GridPack__action":"_1jAYApHM1156jIZKU0ombb","GridPack__learnMore":"b5B9hLhs2t-OSKnlw53Jl","SaleRibbon":"_1Exn-3FbQsDF2lbbJQqsEH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/GridPack/GridPack.scss
// module id = 2301
// module chunks = 0